module.exports = __webpack_public_path__ + "static/media/amcham.9bf46a82.jpg";